import { render } from "./meetBarka.vue?vue&type=template&id=7a616e22&scoped=true"
import script from "./meetBarka.vue?vue&type=script&lang=js"
export * from "./meetBarka.vue?vue&type=script&lang=js"

import "./meetBarka.vue?vue&type=style&index=0&id=7a616e22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a616e22"]])

export default __exports__